export default __webpack_public_path__ + "static/media/logoLine.c7d4805f.webp";